var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"event-password-unavailable",attrs:{"role":"status"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('eventPasswordSaleUnavailableTitle')))]),_c('p',[_vm._v(_vm._s(_vm.$t('eventPasswordSaleUnavailableDescription')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }